import store from 'store2';
import { v4 as uuidv4 } from 'uuid';

const KEY_STORE_REPORTER = 'ksdn.r';

export function getStoredReportInfo() {
  let res = store(KEY_STORE_REPORTER);
  if (!res || !res.browserUserGuid) {
    res = { browserUserGuid: uuidv4() };
    store(KEY_STORE_REPORTER, res);
  }
  return res;
}

export function saveStoredReportInfo(lastDetection) {
  let res = store(KEY_STORE_REPORTER);
  if (!res || !res.browserUserGuid) {
    res = { browserUserGuid: uuidv4() };
  }
  if (lastDetection) {
    res.lastDetection = lastDetection;
  }
  store(KEY_STORE_REPORTER, res);
}
